import moment from "moment";
import AdvanceSearchBetweenDates from "../../components/AdvanceSearchBetweenDates";
import { order } from "../SmartSearchParammeter";

export default async function BetweenDatesSearchConfig(key) {
  return {
    description: "Between Dates",
    id: "startingDate",
    initial: undefined,
    type: order.fourth,
    handleValues: (searchObject) => {
      return;
    },
    Component: (searchObject, setSearchObject, onChange, t) => (
      <div className="col-6 mt-2">
        <AdvanceSearchBetweenDates
          searchObject={searchObject}
          setSearchObject={setSearchObject}
          t={t}
        />
      </div>
    ),
    handleValues: (searchObject) => {
      return;
    },
    operation: ["Between"],
    list: [],

    handler: function (searchObj, value) {
      searchObj["startingDate"] = value[0] ? moment(value[0]) : null;
      searchObj["endingDate"] = value[1] ? moment(value[1]) : null;
    }
  };
}
